module.exports = __webpack_public_path__ + "static/media/econq-logo.ed57e1b0.svg";